<template>
  <div>
    <div id="app" >
    </div>
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'App',
  components: {
    
  },
  watch:{
    $route:function(){
      //路由变化滚动条滚到上面
      window.scrollTo(0,0);
    }
  },
  created(){
    //初始化持久化
    this.$PageUtil.initStateStore(this);
  },
  methods:{
    
  },
  mounted(){
    
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; 
  color: #2c3e50;
  
}
/*美化滚动条*/
::-webkit-scrollbar-track
{
background: rgba(58,58,58,.1);
border-radius: 0;
}

::-webkit-scrollbar
{
-webkit-appearance: none;
width: 6px;
height: 6px;
}

::-webkit-scrollbar-thumb
{
cursor: pointer;
border-radius: 5px;
background: rgba(58,58,58,.25);
transition: color .2s ease;
}
</style>
